import { Button, Form, Input, Modal } from 'antd';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { instanceAuth } from '~/utils/axios';
import { useTranslation } from 'react-i18next';
import { NS } from '~/utils/ns';
const ModalChangePassword = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation([NS['profile']]);
  const [isOpen, setIsOpen] = useState(false);
  const handleCancel = () => {
    setIsOpen(false);
  };
  const handleSubmit = async (data) => {
    try {
      setIsLoading(true);
      const res = await instanceAuth().post('/change-password', data);
      if (res.status) {
        sessionStorage.setItem('auth', res.data);
        toast.success(t('doimkthanhcong'));
        handleCancel();
      } else {
        toast.error(t('mkcukhongchinhxac'));
      }
    } catch (error) {
      console.log(error, 'error nè');
      toast.error(t('common:45'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button className="bg-blue-500 text-white" onClick={() => setIsOpen(true)}>
        {t('change')}
      </Button>
      <Modal open={isOpen} onOk={handleCancel} onCancel={handleCancel} footer={null}>
        <h3 className="font-semibold text-xl text-center">{t('doimkdangnhap')}</h3>
        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label={t('mkhientai')}
            name="oldPassword"
            required
            rules={[{ required: true, message: t('vuilongnhapmkhientai') }]}>
            <Input.Password placeholder={t('nhapmkdangnhap')} />
          </Form.Item>
          <Form.Item
            label={t('newPassword')}
            name="newPassword"
            required
            rules={[{ required: true, message: t('vuilongnhapmkmoi') }]}>
            <Input.Password placeholder={t('nhapmkmoi')} />
          </Form.Item>
          <Form.Item
            label={t('xacnhanmkmoi')}
            name="rePassword"
            required
            rules={[
              {
                required: true,
                message: t('vuilongnhapmkxacnhan'),
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('mkxacnhanktrung')));
                },
              }),
            ]}>
            <Input.Password placeholder={t('nhapmkxacnhan')} />
          </Form.Item>
          <div className="flex justify-end gap-3">
            <Button onClick={handleCancel}>{t('common:cancel')}</Button>
            <Button className="bg-blue-500 text-white" htmlType="submit" loading={isLoading}>
              {t('doimk')}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ModalChangePassword;
